import {
  AtlasButtonProps,
  AtlasIconData,
  AtlasMenuContentDynamicItems,
  Button,
  Icon,
  Menu,
} from "@resource/atlas";
import { atlasEllipsisHorizontal } from "@resource/atlas/icons";
import clsx from "clsx";

type IntegrationCardProps = {
  name: string;
  icon: AtlasIconData;
  subText: string;
  buttonProps: AtlasButtonProps;
  menuItems: AtlasMenuContentDynamicItems | null;
};

export function IntegrationCard(props: IntegrationCardProps) {
  const { name, icon, subText, buttonProps, menuItems } = props;

  return (
    <div className="flex flex-col shadow-1 rounded-md p-6 h-60 w-[304px] group">
      <div className="flex flex-col flex-grow gap-y-4">
        <div className="flex flex-row items-center">
          <div className="flex flex-grow space-x-3 items-center">
            <Icon content={icon} className="w-10 h-10" />
            <p className="text-h4">{name}</p>
          </div>
          {menuItems && (
            <div className="hidden group-hover:block">
              <Menu.Root>
                <Menu.Trigger>
                  <Button icon={atlasEllipsisHorizontal} size="small" />
                </Menu.Trigger>
                <Menu.Content items={menuItems} />
              </Menu.Root>
            </div>
          )}
        </div>
        <div className="text-body-md">{subText}</div>
      </div>
      <div className="flex w-full">
        <Button
          {...buttonProps}
          className={clsx(buttonProps.className, "w-full")}
        />
      </div>
    </div>
  );
}
